<script>
	import { formatFloat, formatInt } from "../map/language";
	import { categoriesById, getBin } from "../constants";

	export let region;
	export let onCloseClick = () => {};

	const frmtTotal = formatInt();
	const frmtPercent = formatFloat({ multiplier: 100, postfix: "%", adaptive: true, decimal: true });

	$: category = categoriesById[region.type];
	$: bin = getBin(region.hours_possible_decimal);
</script>

<div class="tooltip">
	<div class="tooltip-top">
		<div class="header">
			<div class="description">{@html category.labelSingular}</div>
			<div class="title">{@html region.name}</div>
		</div>
		<!-- {#if isSelected} -->
		<div class="button-close" on:click={onCloseClick} />
		<!-- {/if} -->
	</div>
	<div class="location">
		<div class="icon">
			<img src="{PATH}assets/images/icons/icon_pin.svg" />
		</div>
		<div class="text">
			Kiez: {@html region.bzr_name}
		</div>
	</div>
	<div class="number_students">
		<!-- <div class="label"> -->
		<div class="icon">
			<img src="{PATH}assets/images/icons/icon_person.svg" />
		</div>
		<div class="text">Schüler:innen</div>
		<!-- </div> -->
		<div class="number">
			{@html frmtTotal(region.students_total)}
		</div>
	</div>
	<div class="rule" />
	<div class="teaching-supply" style:background-color={bin.backgroundColor} style:color={bin.textColor}>
		<div class="percentage">
			{@html frmtPercent(region.hours_possible_decimal)}
		</div>
		<div class="description">
			{@html bin.label}
		</div>
		<div class="chart">
			<img src={bin.chartPath} />
		</div>
	</div>
	<div class="hours">
		<div class="icon">
			<img src="{PATH}assets/images/icons/icon_clock.svg" />
		</div>
		<div class="text">
			<b>{frmtTotal(region.hours_possible)} von {frmtTotal(region.hours_needed)}</b> not&shy;wend&shy;igen Unter&shy;richts&shy;stunden
			im Schul&shy;jahr 2022/23 konnten angeboten werden.
		</div>
	</div>
	<div class="rank">
		<div class="icon">
			<img src="{PATH}assets/images/icons/icon_rank.svg" />
		</div>
		<div class="text">
			Die Schule belegt hin&shy;sicht&shy;lich der Ver&shy;sorg&shy;ung Rang&nbsp;<b
				>{frmtTotal(region.hours_possible_rank_within_type)}</b
			>&nbsp;/&nbsp;{category.count}
			aller
			{@html category.label}.
		</div>
	</div>
</div>

<style lang="scss">
	$grey: #807d8d;

	.tooltip {
		background: white;
		padding: 11px 14px 16px 14px;
		position: absolute;
		top: 145px;
		right: 10px;
		font-size: 14px;
		line-height: 20px;
		border-radius: 3px;
		box-shadow: 0 4px 5px rgba(0, 0, 0, 0.15);
		width: 330px;
		box-sizing: border-box;
		z-index: 1;

		@media (min-width: #{$breakpoint-mobile-l + 1px}) and (max-width: $breakpoint-tablet-s) {
			width: 300px;
		}

		.icon {
			width: 18px;
		}

		.rule {
			height: 1px;
			background: #d9d9d9;
			opacity: 0.3;
			margin: 10px 0;
		}

		.tooltip-top {
			display: flex;
			justify-content: space-between;

			.title {
				font-weight: 600;
				font-size: 18px;
				line-height: 21px;
				margin-bottom: 5px;
			}

			.description {
				color: $grey;
				letter-spacing: 0.65px;
				text-transform: capitalize;
			}

			.button-close {
				cursor: pointer;
				background-position: center center;
				background-image: url(../assets/images/icons/icon_close.svg);
				width: 20px;
				height: 20px;
				background-size: contain;
				flex-shrink: 0;

				// @media (max-width: $breakpoint-mobile-l) {
				// 	background-image: url(../assets/images/icons/icon_back.svg);
				// }
			}
		}

		.location,
		.number_students {
			display: flex;
			font-weight: $medium;
			font-size: 16px;
			letter-spacing: 0.16px;

			.text {
				color: $grey;
			}

			.number {
				flex-grow: 1;
				text-align: right;
			}
		}
		.teaching-supply {
			display: flex;
			border-radius: 5px;
			transition: background-color 0.3s ease-in-out, color 0.3s ease-in-out;
			letter-spacing: 0.2px;
			padding: 5px 10px;
			align-items: center;
			margin: 10px auto;

			.percentage {
				font-weight: $bold;
				font-size: 20px;
				margin-right: 8px;
			}

			.description {
				font-weight: $medium;
				white-space: nowrap;
				flex-grow: 2;
			}

			.chart {
				flex-shrink: 1;
				flex-basis: 70px;
				display: flex;

				img {
					// width: 70px;
					width: 100%;
				}
			}
		}

		.hours,
		.rank {
			display: flex;
			column-gap: 8px;
		}

		@media (max-width: $breakpoint-mobile-l) {
			position: absolute;
			top: calc(100% - #{$tooltip-offset});
			width: 100%;
			left: 0;
			right: 0;
			border-radius: 10px;
			box-shadow: 0 3px 10px rgba(0, 0, 0, 0.3);
			padding: 10px 13px 13px 13px;

			.button-close {
				margin-right: 0px;
			}

			.header {
				position: relative;
				padding-right: 20px;
				// margin-bottom: 8px;
			}
		}
	}
</style>
